import { useFeder } from "../../lib/spring";

type Art = "euro" | "cm" | "m" | "grad" | "zahl" | "prozent" | "qm" | "kg";

const FORMATE: Record<Art, (n: number) => string> = {
  euro: (n) => n.toLocaleString("de-DE", { style: "currency", currency: "EUR" }),
  cm: (n) => `${n.toLocaleString("de-DE", { maximumFractionDigits: 1 })} cm`,
  m: (n) => `${n.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} m`,
  qm: (n) => `${n.toLocaleString("de-DE", { maximumFractionDigits: 2 })} m²`,
  kg: (n) => `${n.toLocaleString("de-DE", { maximumFractionDigits: 1 })} kg`,
  grad: (n) => `${n.toLocaleString("de-DE", { maximumFractionDigits: 1 })}°`,
  prozent: (n) => `${n.toLocaleString("de-DE", { maximumFractionDigits: 0 })} %`,
  zahl: (n) => n.toLocaleString("de-DE", { maximumFractionDigits: 2 }),
};

/**
 * Zahl, die sich zum neuen Wert hinbewegt statt zu springen. Startet immer vom
 * gerade sichtbaren Wert – auch wenn mitten in der Bewegung ein neuer kommt.
 */
export function Zahl({ wert, art = "zahl", className }: { wert: number; art?: Art; className?: string }) {
  const animiert = useFeder(wert, { response: 0.4, damping: 1 });
  return (
    <span className={`kalk-zahl${className ? ` ${className}` : ""}`} aria-label={FORMATE[art](wert)}>
      {FORMATE[art](animiert)}
    </span>
  );
}
